import { generateHelpers as o } from "@lokalise/styled";
import { themes as r } from "../../foundations/themes/index.js";
const { color: p, spacing: a, font: i, radius: n, transition: s, typography: m, zIndex: g, value: l, valueFromProp: y } = o(
  r.light,
  {
    objectKeys: ["typography"]
  }
);
export {
  p as color,
  i as font,
  n as radius,
  a as spacing,
  s as transition,
  m as typography,
  l as value,
  y as valueFromProp,
  g as zIndex
};
//# sourceMappingURL=index.js.map
